const callWith =
    <T extends any[], R>(callback?: (...args: T) => R, ...args: T) =>
    <E extends any[]>(..._: E) =>
        callback?.(...args);

export { callWith };
